"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
const forms_1 = require("@angular/forms");
const http_1 = require("@angular/http");
const translate_module_1 = require("./../../translate/src/translate.module");
const resource_service_1 = require("./resources/resource.service");
const motion_component_1 = require("./motion/motion.component");
const motionline_component_1 = require("./motionLine/motionline.component");
//import { FinalPositionComponent } from './finalPosition/finalPosition.component';
const motionUi_routing_1 = require("./motionUi.routing");
const commonUi_module_1 = require("../../commonUi/src/commonUi.module");
const motion_1 = require("../../motion/src/motion");
const motionTexts_1 = require("../../motion/src/motionTexts");
const motionTextsPipe_1 = require("../../motion/src/motionTextsPipe");
let MotionUiModule = class MotionUiModule {
    //Resource manager adds the translations to the translationservice
    constructor(_resourceManager) {
        this._resourceManager = _resourceManager;
    }
};
MotionUiModule = __decorate([
    core_1.NgModule({
        imports: [
            //Modules
            platform_browser_1.BrowserModule,
            forms_1.FormsModule,
            http_1.HttpModule,
            translate_module_1.TranslateModule,
            commonUi_module_1.CommonUiModule,
            motionUi_routing_1.MOTION_ROUTES
        ],
        exports: [
            motion_component_1.MotionComponent
        ],
        declarations: [
            //Components
            motion_component_1.MotionComponent,
            motionline_component_1.MotionLineComponent,
            motionTextsPipe_1.InaxMotionTextsPipe
        ],
        providers: [
            resource_service_1.MotionUiResourceManager,
            motion_1.InaxMotionService,
            motionTexts_1.InaxMotionTextsService
        ],
        bootstrap: []
    }),
    __metadata("design:paramtypes", [resource_service_1.MotionUiResourceManager])
], MotionUiModule);
exports.MotionUiModule = MotionUiModule;
